import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { getStoredOrgTimeZone, useOrganizationSettings } from '@/hooks/use-settings';

interface OrganizationSettingsGateProps {
  children: ReactNode;
}

export function OrganizationSettingsGate({ children }: OrganizationSettingsGateProps) {
  const { user } = useAuth();
  const {
    data: settings,
    isPending,
    isError,
    refetch,
    isFetching,
    fetchStatus,
  } = useOrganizationSettings();
  const storedTimeZone = getStoredOrgTimeZone(user?.organization);

  if (settings || (storedTimeZone && (fetchStatus === 'paused' || !navigator.onLine))) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        {isPending || isFetching ? (
          <>
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
            <p className="text-sm text-gray-500">Loading organization settings...</p>
          </>
        ) : isError ? (
          <>
            <p className="text-sm text-red-600">Unable to load organization settings.</p>
            <button
              type="button"
              className="rounded bg-blue-600 px-4 py-2 text-sm text-white"
              onClick={() => void refetch()}
            >
              Try again
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
}
